import './composition-block.scss';

/**
 * version    1.0
 * class      <type> (Card)
 * classdesc  Component that manage the page header
 */
export class CompositionBlock {}
